import { render, staticRenderFns } from "./workorderDbh.vue?vue&type=template&id=0961d151&"
import script from "./workorderDbh.vue?vue&type=script&lang=js&"
export * from "./workorderDbh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports